var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size}},[_c('v-img',{attrs:{"if":"avatarUrl","src":_vm.avatarUrl}}),_c('v-icon',{attrs:{"else":""}},[_vm._v("account_circle")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }